
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { DbUser } from "../models";
import { BaseDbObject } from "../models/db";
import { Customer } from "./reports";
import {
    fetchApiDelete,
    fetchApiGet,
    fetchApiPost,
    fetchApiPut,
} from "./utils";

const ListQuerySchema = z.object({
  page: z.string().regex(/^\d+$/).transform(Number).optional(),
  limit: z.string().regex(/^\d+$/).transform(Number).optional(),
  date: z.string().optional(), // YYYY-MM-DD format
});



export interface GrainPosition {
    trade_date?: string;
    buy_sell?: string;
    quantity?: string;
    derived_quantity?: string;
    comments?: string;
    put_or_call?: string;
    price?: string;
    broker?: string;
    account?: string;
    order_number?: string;
    trade_type?: string;
    commodity_symbol?: string;
    commodity_group_type?: string;
    option_month?: string;
    year?: string;
    week?: string;
}

export function useListGrainSamplesActive(filters: z.infer<typeof ListQuerySchema>) {
  const queryParams = new URLSearchParams();
  if (filters.page) {
      queryParams.append("page", filters.page.toString());
  }

  if (filters.limit) {
      queryParams.append("limit", filters.limit.toString());
  }

  if (filters.date) {
      queryParams.append("date", filters.date.toString());
  }

  return useQuery({
    queryKey: ["grain", "positions", queryParams.toString()],
    queryFn: () => fetchApiGet<GrainPosition[]>(`grain_position/futures`, queryParams),
    retry: 1,
  });
}
